export default __webpack_public_path__ + "static/media/googleNoBackGrIcon.9bc6b2a2.svg";